import React from 'react';
import { Col, Row } from 'react-bootstrap';

const Spring = () => {
    return (
        <Row className="my-4 p-4 Springrow d-flex justify-content-center align-items-center">
            <Col  className="p-4 weddingcolam"  lg={5} md={10} sm={12}>
                <h1 className="weddingtitle text-center springtxt">Spring Flowers</h1>
            </Col>
        </Row>
    );
};

export default Spring;